export default __webpack_public_path__ + "static/media/rafael.249366a3.png";